import { useEffect, useState } from "react";
import { useUser } from "../../auth";
import { Redirect } from "react-router";

const Logout = () => {
  const [loading, setLoading] = useState(true);
  const { logout } = useUser();

  useEffect(() => {
    logout().then(() => {
      setLoading(false);
    });
  }, [logout]);

  return loading ? <div /> : <Redirect to="/" />;
};

export default Logout;
